module.exports = __webpack_public_path__ + "img/hr-centrifuge-C-light.77fbec9c.png";